module.exports = "<div class=\"ppa-spinner\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>";